




































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { State, Mutation, namespace } from 'vuex-class'
import PageLayout from '@/components/page/PageLayout.vue'
import UserApi from '@/api/user'
let timer: any = ''
import { passwordReg } from '@/utils/regExp'
import { passwordValidate } from '@/utils/validator'

@Component({
	name: 'ChangePassword',
	components: {
		PageLayout,
	},
})
export default class PassWord extends Vue {
	private loading: boolean = false
	private txt: any = '获取验证码'
	private disabled: boolean = false
	private passwordReg: any = passwordReg
	private formItemLayout: any = {
		labelCol: {
			span: 3,
		},
		wrapperCol: {
			span: 8,
		},
	}

	private submitFormLayout: any = {
		wrapperCol: {
			xs: { span: 3, offset: 2 },
		},
	}

	public checkPass(rule: string, value: string, cb: any) {
		value = value || ''
		const res = passwordValidate(value)
		if (res === true) {
			cb()
		} else {
			cb(new Error(res))
		}
	}

	private form: any = {}
	private created() {
		this.form = this.$form.createForm(this)
	}

	private get mobile() {
		const mobile = this.$store.getters.userInfo.mobile.split('')
		for (let i = 3; i < 7; i++) {
			mobile[i] = '*'
		}
		return mobile.join('')
	}

	private async getForgotPwdValidateCode() {
		this.form.resetFields(['validCode'])
		try {
			this.disabled = true
			let sec = 60
			this.txt = `已发送(${sec}s)`
			clearInterval(timer)
			timer = setInterval(() => {
				sec--
				if (sec <= 0) {
					this.disabled = false
					clearInterval(timer)
					this.txt = '重新发送短信'
					return
				}
				this.txt = `已发送(${sec}s)`
			}, 1000)
			await UserApi.sendByUserMobile()
		} catch ({ errors }) {
			clearInterval(timer)
			this.txt = '获取验证码'
			this.disabled = false
		}
	}

	private handleSubmit(e: any) {
		e.preventDefault()
		this.form.validateFields((err: any, values: any) => {
			if (!err) {
				delete values.confirmPwd
				UserApi.modifiedPwd(values).then((res: any) => {
					this.form.resetFields()
					this.$message.success('密码修改成功！')
				})
			}
		})
	}

	private confirm(rule: string, value: string, cb: any) {
		const newPwd = this.form.getFieldValue('newPwd')
		if (!value) {
			cb(new Error('请确认新密码'))
		} else if (value !== newPwd) {
			cb(new Error('两次输入密码不一致'))
		} else {
			cb()
		}
	}
}
